import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'partnerGroupsFilter', namespaced: true })
export default class PartnerGroupsFilter extends FilterModule {
    constructor(module: PartnerGroupsFilter) {
        super(module);
    }
}
